import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";
import { ROLE_OPTIONS, getAssignableRoles } from "@/lib/roles";
import { useAuth } from "@/context/AuthContext";
import { PermsMatrix } from "@/components/PermsMatrix";
import { PermsSection, EmpresasSelector } from "./PermsSection";

// Card superior "Novo usuário" — form completo de criação.
export function UsuariosNewUserCard({
  f, setF, entregadores, empresas, customPresets,
  onAdd, onTogglePerm, onToggleEmpresa, onSetAllPerms, onApplyPreset,
  onOpenSavePreset, onDeleteCustomPreset,
}) {
  const { user } = useAuth();
  const assignableRoles = getAssignableRoles(user);
  return (
    <Card>
      <CardHeader><CardTitle>Novo usuário</CardTitle></CardHeader>
      <CardContent className="grid md:grid-cols-5 gap-3 items-end">
        <Input data-testid="user-nome" placeholder="Nome completo"
          value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} />
        <Input data-testid="user-email" placeholder="Email" type="email"
          value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <Input data-testid="user-username" placeholder="Usuário curto (opcional, p/ login rápido)"
          value={f.username} onChange={(e) => setF({ ...f, username: e.target.value.replace(/\s+/g, "").toLowerCase() })} />
        <Input data-testid="user-senha" placeholder="Senha" type="password"
          value={f.senha} onChange={(e) => setF({ ...f, senha: e.target.value })} />
        <Select value={f.role} onValueChange={(v) => setF({ ...f, role: v })}>
          <SelectTrigger data-testid="user-role"><SelectValue placeholder="Perfil do Usuário" /></SelectTrigger>
          <SelectContent>
            {assignableRoles.map((r) => (
              <SelectItem key={r.value} value={r.value} data-testid={`role-opt-${r.value}`}>
                <div className="flex flex-col">
                  <span className="font-semibold">{r.label}</span>
                  <span className="text-[10px] text-muted-foreground">{r.hint}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button data-testid="btn-add-user" onClick={onAdd} className="bg-orange-600 hover:bg-orange-700">
          <Plus className="w-4 h-4 mr-2" />Adicionar
        </Button>
        <div className="md:col-span-5">
          <div className="text-sm font-semibold mb-2">Vincular a Entregador (opcional — habilita app mobile)</div>
          <Select value={f.entregador_id || "__none__"}
            onValueChange={(v) => setF({ ...f, entregador_id: v === "__none__" ? "" : v })}>
            <SelectTrigger data-testid="user-entregador"><SelectValue placeholder="Nenhum" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__none__">— Nenhum —</SelectItem>
              {entregadores.map((e) => <SelectItem key={e.id} value={e.id}>{e.nome}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-5">
          <div className="text-sm font-semibold mb-2">
            Empresas de acesso <span className="text-xs text-muted-foreground font-normal">
              (Super Admin vê todas · demais perfis são restritos às empresas marcadas)
            </span>
          </div>
          <EmpresasSelector empresas={empresas} selectedIds={f.empresa_ids} onToggle={onToggleEmpresa} target="f" />
        </div>
        <div className="md:col-span-5">
          <PermsSection
            target="f"
            permissions={f.permissions}
            customPresets={customPresets}
            onApplyPreset={onApplyPreset}
            onDeleteCustomPreset={onDeleteCustomPreset}
            onSetAllPerms={onSetAllPerms}
            onOpenSavePreset={onOpenSavePreset}
            onTogglePerm={onTogglePerm}
            testIdPrefix=""
          />
        </div>
        <div className="md:col-span-5">
          <PermsMatrix value={f.perms_matrix} onChange={(m) => setF({ ...f, perms_matrix: m })} testIdPrefix="matrix" />
        </div>
      </CardContent>
    </Card>
  );
}
